import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const DialogStyled = styled(Dialog)`
  display: flex;
  align-items: center;
  justify-content: center;
`

class GenericDialog extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      openDialog: props.open,
    }
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.open !== this.state.openDialog) {
      this.setState({openDialog: nextProps.open})
    }
  }

  closeDialog = () => {
    const { onClose } = this.props
    this.setState({openDialog: false})
    if(onClose){
      onClose();
    }
  }

  render(){
    const {
        open,
        handleAgree,
        handleClose,
        title,
        content,
        cancelText,
        agreeText,
        showCancel,
        ...other
    } = this.props;

    const { openDialog } = this.state;

    return (
      <DialogStyled open={openDialog} {...other}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          {
            showCancel &&
            <Button onClick={handleClose} color="primary">
              {cancelText}
            </Button>
          }
          <Button onClick={handleAgree} color="primary" autoFocus>
            {agreeText}
          </Button>
        </DialogActions>
      </DialogStyled>
    );
  }
}

GenericDialog.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  agreeText: PropTypes.string.isRequired,
  cancelText: PropTypes.string,
};

GenericDialog.defaultProps = {
  cancelText: 'Cancel',
  showCancel: true,
}

export default GenericDialog;
